import { Modal as RBModal } from "react-bootstrap";
import { Modal as ANTModal } from "antd";
import styled from "styled-components";

export const StyledModal12 = styled(ANTModal)`
  --bs-modal-zindex: 9999999;
  --modal-primary-color: #518bb4;

  .modal-content {
    border: 4px solid var(--modal-primary-color);
    background: #fefefe;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.32), 10px 10px 30px 0 rgba(0, 0, 0, 0.4);
    border-radius: 6px;
  }
  @media (min-width: 576px) {
    .modal-xxl{max-width: 1330px;}
  }
  &.unstyle-padding .modal-body{
   padding:0;
  }
`;
export const StyledModal = styled(ANTModal)`
 --bs-modal-zindex: 9999999;
  --modal-primary-color: #518bb4;
   .ant-modal-header{
    background-color: var(--modal-primary-color);
    border-radius: unset;
    color: white;
    text-transform: uppercase;
    padding:0.5rem 1rem;
    font-weight: 500;
    line-height: 1.2;
    font-size: 1rem;
   }
  .ant-modal-content {
    border: 4px solid var(--modal-primary-color);
    background: #fefefe;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.32), 10px 10px 30px 0 rgba(0, 0, 0, 0.4);
    border-radius: 6px;
    padding:0;
    .modal-body{
     padding:0;
     overflow:unset;
     max-height:100%;
    }
    .ant-modal-body{
    padding:1rem;
    }
  }
  .ant-modal-body {
    max-height: 80vh;
    overflow: auto;
   }
     &.no-header{
     .ant-modal-content {
      padding-top: 48px;}
  }
  .ant-modal-title{
  color:var(--text-color-white)
  }
  .ant-modal-footer{
    padding: 1rem;
    border-top: 1px solid var(--grey-color-light);
  }
  .ant-modal-close {
    top: 2px;
    right: 0px;
    background: #fff !important;
  }
    &.unstyle-padding{
      .ant-modal-header{
       margin-bottom:0px;
      }
      .ant-modal-body{
        padding:0;
      }
    }
  
  &.ant-custom-action-footer{
   .ant-modal-body {
   padding-bottom:0px;
   }
    .ant-modal-content > .ant-modal-footer{
    display:none;
    }
    .ant-modal-footer.custom{
    padding-left:0px;
    padding-right:0px;
    padding-bottom:0px;
    position: sticky;
    bottom: 0;
    background: #fff;
    }
  }
`

export const ANTStyledModal = styled(ANTModal)`
  --bs-modal-zindex: 9999999;
  --modal-primary-color: #518bb4;
   .ant-modal-header{
    background-color: var(--modal-primary-color);
    border-radius: unset;
    color: white;
    text-transform: uppercase;
    padding:0.5rem 1rem;
    font-weight: 500;
    line-height: 1.2;
    font-size: 1rem;
   }
  .ant-modal-content {
    border: 4px solid var(--modal-primary-color);
    background: #fefefe;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.32), 10px 10px 30px 0 rgba(0, 0, 0, 0.4);
    border-radius: 6px;
    padding:0;
    .modal-body{
     padding:0;
     overflow:unset;
     max-height:100%;
    }
    .ant-modal-body{
    padding:1rem;
    }
  }
  .ant-modal-body {
    max-height: 80vh;
    overflow: auto;
   }
     &.no-header{
     .ant-modal-content {
      padding-top: 48px;}
  }
  &.questionnaire-modal.no-header{
    .ant-modal-content {padding-top: 18px;}
  }
  .ant-modal-title{
  color:var(--text-color-white)
  }
  .ant-modal-footer{
    padding: 1rem;
    border-top: 1px solid var(--grey-color-light);
  }
  .ant-modal-close {
    top: 2px;
    right: 0px;
    background: #fff !important;
  }
    &.unstyle-padding{
      .ant-modal-header{
       margin-bottom:0px;
      }
      .ant-modal-body{
        padding:0;
      }
    }
  
  &.ant-custom-action-footer{
   .ant-modal-body {
   padding-bottom:0px;
   }
    .ant-modal-content > .ant-modal-footer{
    display:none;
    }
    .ant-modal-footer.custom{
    padding-left:0px;
    padding-right:0px;
    padding-bottom:0px;
    position: sticky;
    bottom: 0;
    background: #fff;
    }
  }
`;

export const ModalHeader = styled(RBModal.Header)`
  background-color: var(--modal-primary-color);
  border-radius: unset;
  color: white;
  text-transform: uppercase;
  --bs-modal-header-padding: 0.5rem 1rem;
  font-weight: 500;
  line-height: 1.2;
  font-size: 1rem;
`;

export const ModalTitle = styled(RBModal.Title)``;

export const ModalBody = styled(RBModal.Body)`
  max-height: 80vh;
  overflow: auto;
`;

export const ModalFooter = styled(RBModal.Footer)`
  gap: 10px;
  &.modal-unstyled-footer{
   border-top-width:0;
   gap: 0px;
   padding: 0;
  }
`;
